webpackJsonp([195851832060080],{

/***/ 762:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/bad-hair-days/"},"excerpt":"Have you ever had a bad hair day? Most days, it seems no matter how much I preen, I just cannot get my mane to settle down. I’ve tried…","timeToRead":1,"frontmatter":{"title":"Bad Hair Days","tags":["big cats","felines","grooming","hair care","mammals"]}}}]}},"pathContext":{"tag":"grooming"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-grooming-d536b138b9cbd4d9376f.js